import moment from 'moment';
import { ajoutLignesCommandeProduitReseauNumeriqueViaObject }
  from '@/services/devisCommandes/ajoutProduit/ajoutProduitReseauNumerique';
import { ajoutLignesCommandeProduitEcranNumeriqueViaObject }
  from '@/services/devisCommandes/ajoutProduit/ajoutProduitEcranNumerique';
import genererLigneCommande from '@/services/devisCommandes/genererLigneCommande';
import modificationLigne from '@/services/devisCommandes/modificationLigneCommande';
import calculCommandeDevis from '@/services/devisCommandes/calcul/calculCommandeDevis';
import * as produitConf from '@/configuration/catalogue/produitConf';
import creationRegroupementPersonnalise from '@/services/devisCommandes/regroupementPersonnalise/creationRegroupementPersonnalise';
import validationRegroupementPersonnalise from '@/services/devisCommandes/regroupementPersonnalise/validationCreationRegroupementPersonnalise';
import maxOrderBaseGetter from '@/services/devisCommandes/maxOrderBaseGetter';
import ajoutOrdre from '@/services/devisCommandes/ajoutOrdre';
import reordonnancementRegroupementPersonnalise from '@/services/devisCommandes/regroupementPersonnalise/reordonnancementRegroupementPersonnalise';
import { get as getProduitLocationNum } from '@/api/produit/produitLocation';
import updateLignesCommandeWithPanierAndType from '@/services/devisCommandes/ligneCommande/updateLignesCommandeWithPanierAndType';
import { addReferenceEcheancierToLigneCommande }
  from '@/services/commande/echeancierFacturation/addReferenceEcheancierToLigneCommande';
import fusionEcheancier from '@/services/commande/echeancierFacturation/fusionEcheancier';
import {
  TYPE_COMMANDE, TYPE_DEVIS, SOUS_TYPE_AVOIR,
  SOUS_TYPE_AVOIR_SUR_ACOMPTE,
} from '@/configuration/devisConf';

function fusionRegroupementPerso(lignes, devisCommande) {
  let referencesEcheancier = [];
  lignes.forEach((ligne) => {
    if (ligne.referenceEcheancier) referencesEcheancier.push(ligne.referenceEcheancier);
    if (ligne.lignesCommande) {
      referencesEcheancier = referencesEcheancier.concat(
        ligne.lignesCommande.map((ligneEnfant) => { return ligneEnfant.referenceEcheancier; }),
      );
    }
  });
  if (devisCommande.type === TYPE_COMMANDE || devisCommande.type === TYPE_DEVIS) {
    fusionEcheancier(referencesEcheancier, devisCommande);
  }
}

function regroupementPersonnalise(selectedLines, devisCommande, i18n, messages) {
  selectedLines.forEach(ligne => {
    ligne.selected = true;
  });
  if (validationRegroupementPersonnalise(
    selectedLines, devisCommande, messages,
  )) {
    creationRegroupementPersonnalise(
      selectedLines, devisCommande.lignesCommande, i18n,
    );
    fusionRegroupementPerso(selectedLines, devisCommande);
    selectedLines.forEach(ligne => {
      ligne.selected = false;
    });
  }
}

export async function ajouterProduitDepuisPanierNumerique(
  panier, devisCommande, isRegroupPerso, i18n, messages, tauxTva,
) {
  const listeProduit = Object.values(panier);
  if (listeProduit.length === 0) return devisCommande;
  const typeProduitNumerique = listeProduit[0].typeProduit;
  const lignesAjouter = [];
  const promesseLigneAAjouter = [];

  let produitsLocationId = [];
  listeProduit.forEach(produit => {
    produitsLocationId = produitsLocationId.concat(produit.periode.map(periode => {
      return periode.produitLocationNum.id;
    }));
  });
  produitsLocationId = Array.from(new Set(produitsLocationId));
  const promesseProduitLocation = [];
  produitsLocationId.forEach(id => {
    promesseProduitLocation.push(getProduitLocationNum(id));
  });
  const produitsLocationResult = await Promise.all(promesseProduitLocation);
  listeProduit.forEach(produit => {
    produit.periode.forEach(p => {
      const ligneCommandeAAjouter = genererLigneCommande(
        maxOrderBaseGetter(devisCommande.lignesCommande) + 1,
      );
      devisCommande.lignesCommande.push(ligneCommandeAAjouter);
      p.dateDebut = moment(p.dateDebut);
      p.dateFin = moment(p.dateFin);

      // a supprimer quand on aura la location complete dans le panier
      const produitLocation = produitsLocationResult.find(resultLocation => {
        return resultLocation.data.result.id === p.produitLocationNum.id;
      }).data.result;

      if (typeProduitNumerique === produitConf.CATEGORIE_REGROUPEMENT_NUMERIQUE) {
        promesseLigneAAjouter.push(ajoutLignesCommandeProduitReseauNumeriqueViaObject(
          devisCommande, produit.produitComplet,
          produitLocation, ligneCommandeAAjouter.ordre, p,
        ));
      } else if (typeProduitNumerique === produitConf.CATEGORIE_ECRAN_NUMERIQUE) {
        promesseLigneAAjouter.push(ajoutLignesCommandeProduitEcranNumeriqueViaObject(
          devisCommande, produit.produitComplet,
          produitLocation, ligneCommandeAAjouter.ordre, p, typeProduitNumerique,
        ));
      }
    });
  });
  const resultPromesseLigneAAjouter = await Promise.all(promesseLigneAAjouter);
  resultPromesseLigneAAjouter.forEach(resultLigneAAjouter => {
    const ligne = resultLigneAAjouter[0];
    modificationLigne(devisCommande, ligne.ordre, ligne);
    addReferenceEcheancierToLigneCommande(ligne, devisCommande);
    if (tauxTva !== null && tauxTva !== undefined) {
      ligne.tauxTva = tauxTva;
      if (ligne.lignesCommande) {
        ligne.lignesCommande.forEach((ligneEnfant) => {
          ligneEnfant.tauxTva = tauxTva;
        });
      }
    }
    lignesAjouter.push(ligne);
  });
  if (devisCommande.sousType === SOUS_TYPE_AVOIR
      || devisCommande.sousType === SOUS_TYPE_AVOIR_SUR_ACOMPTE) {
    devisCommande.lignesCommande.forEach(ligne => {
      ligne.quantite *= -1;
      if (ligne.lignesCommande && Array.isArray(ligne.lignesCommande)) {
        ligne.lignesCommande.forEach(sousLigne => {
          sousLigne.quantite *= -1;
        });
      }
    });
  }
  calculCommandeDevis(devisCommande);
  if (isRegroupPerso) regroupementPersonnalise(lignesAjouter, devisCommande, i18n, messages);
  return devisCommande;
}

export function ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
  panier, devisCommande, isRegroupPerso, i18n, messages, categorie, tauxTva,
) {
  devisCommande.lignesCommande = updateLignesCommandeWithPanierAndType(
    devisCommande.lignesCommande, categorie, panier, devisCommande, tauxTva,
  );
  reordonnancementRegroupementPersonnalise(devisCommande.lignesCommande);
  devisCommande.lignesCommande.forEach((ligneCommande) => {
    ajoutOrdre(ligneCommande, devisCommande.lignesCommande.indexOf(ligneCommande));
  });
  calculCommandeDevis(devisCommande);
  if (isRegroupPerso) regroupementPersonnalise(panier, devisCommande, i18n, messages);
  return devisCommande;
}
